import { createApi } from "@reduxjs/toolkit/query/react";
import { DynamicBaseQuery } from "./baseQuery";
import { AuditLogsIndexRequest } from "./types/auditLogs/requests/AuditLogsIndexRequest";
import { AuditLogsIndexResponse } from "./types/auditLogs/responses/AuditLogsIndexResponse";
import { AuditLogFilterResponse } from "./types/auditLogs/responses/AuditLogFilterRespones";
import { ExportAuditLogsResponse } from "./types/auditLogs/responses/ExportAuditLogsResponse";
import { AuditLogsExportRequest } from "./types/auditLogs/requests/AuditLogsExportRequest";
import { AuditLogsGeneratedExportsResponse } from "./types/auditLogs/responses/AuditLogsGeneratedExportsResponse";
import { AuditLogsGeneratedExportRequest } from "./types/auditLogs/requests/AuditLogsGeneratedExportRequest";

export const auditLogsApi = createApi({
  reducerPath: "auditLogsApi",
  baseQuery: DynamicBaseQuery,
  tagTypes: ["AuditLogs", "AuditLogFilters"],
  endpoints: (builder) => ({
    getAuditLogs: builder.query<AuditLogsIndexResponse, AuditLogsIndexRequest>({
      query: (params) => ({
        url: "/audit-log",
        method: "GET",
        params,
      }),
      providesTags: ["AuditLogs"],
    }),
    getAuditLogFilters: builder.query<AuditLogFilterResponse, void>({
      query: () => ({
        url: "/audit-log/filters",
        method: "GET",
      }),
      keepUnusedDataFor: Infinity,
      providesTags: ["AuditLogFilters"],
    }),
    generateExportAuditLog: builder.mutation<
      ExportAuditLogsResponse,
      AuditLogsExportRequest
    >({
      query: (params) => ({
        url: "/audit-log/export",
        method: "POST",
        params,
      }),
    }),
    downloadAuditLog: builder.mutation<Blob, { exportId: number }>({
      query: ({ exportId }) => ({
        url: `/audit-log/export/${exportId}/download`,
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),
    getGeneratedExports: builder.query<
      AuditLogsGeneratedExportsResponse,
      AuditLogsGeneratedExportRequest
    >({
      query: (params) => ({
        url: "/audit-log/exports",
        method: "GET",
        params,
      }),
    }),
  }),
});

export const {
  useGetAuditLogsQuery,
  useGetAuditLogFiltersQuery,
  useGenerateExportAuditLogMutation,
  useDownloadAuditLogMutation,
  useLazyGetGeneratedExportsQuery,
} = auditLogsApi;
